import { Story } from '../../DocTypes';

export const templateButtonWithPopover: Story = {
  title: 'Template button with popover',
  description: 'List which contains a button with a popover',
  coreComponent: {
    html: `<tag-list height='300px'>
    <template>
      <div style='display:flex; align-items:center; padding: 5px 0px;'>
        <tag-text text='{{name}}' text-style='{"width": "150px"}'></tag-text>
        <tag-text text='{{position}}' text-style='{"font-style": "italic"}'></tag-text>
        <tag-button text='Button' data-popover='popover{{buttonId}}' button-style='{"margin-left": "50px"}' ></tag-button>
        <tag-popover popover-for='[data-popover="popover{{buttonId}}"]' position="auto">
          <div >
            <tag-field value="Whatever you want" value-style='{"font-size": "20px", "margin": "15px"}'></tag-field>
          </div>
        </tag-popover>
        </div>
    </template>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
    tagList.componentOnReady().then(function() {
      tagList.setData([
        { name: 'Jordan Pickford', position: 'Goalkeeper', buttonId: '0' },
        { name: 'Kyle Walker', position: 'Right back', buttonId: '1' },
        { name: 'John Stones', position: 'Centre Back', buttonId: '2' },
        { name: 'Harry Maguire', position: 'Centre Back', buttonId: '3' },
        { name: 'Luke Shaw', position: 'Attacking Midfield', buttonId: '4' }
      ]);
    });
    `,
  },
  reactWrapper: {
    jsx: `<TagList
    renderItem={({name, position, buttonId}) => (
      <div style={{display:'flex', alignItems:'center', padding: '5px 0px'}}>
        <TagText text={name} textStyle={{width: '150px'}} />
        <TagText text={position} textStyle={{fontStyle: 'italic'}} />
        <TagButton
            id="button-1"
            data-popover={"popover"+buttonId}
            text="Click Me"
            buttonStyle={{ marginLeft: '50px' }}
          />
        <TagPopover popoverFor={"[data-popover='popover"+buttonId+"']"} position="auto">
          <div >
              <tag-field value="Whatever you want" value-style='{"font-size": "20px", "margin": "15px"}'></tag-field>
          </div>
        </TagPopover>
      </div>
    )}
    data={[
      { name: 'Jordan Pickford', position: 'Goalkeeper', buttonId: '0' },
      { name: 'Kyle Walker', position: 'Right back', buttonId: '1' },
      { name: 'John Stones', position: 'Centre Back', buttonId: '2' },
      { name: 'Harry Maguire', position: 'Centre Back', buttonId: '3' },
      { name: 'Luke Shaw', position: 'Attacking Midfield', buttonId: '4' }
    ]}
  />`,
  },
};
